import { render, staticRenderFns } from "./form_config.vue?vue&type=template&id=7ee4f0a6&scoped=true&"
import script from "./form_config.vue?vue&type=script&lang=js&"
export * from "./form_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee4f0a6",
  null
  
)

export default component.exports